import type { PermissionGroup, Role } from "@/types/rbac";
import { RoleCard } from "./RoleCard";

interface RolesListProps {
  roles: Role[];
  permissionGroups: PermissionGroup[];
  onEdit: (role: Role) => void;
  onDelete: (role: Role) => void;
  canUpdate?: boolean;
  canDelete?: boolean;
}

export function RolesList({
  roles,
  permissionGroups,
  onEdit,
  onDelete,
  canUpdate = true,
  canDelete = true,
}: RolesListProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {roles.map((role) => (
        <RoleCard
          key={role.id}
          role={role}
          permissionGroups={permissionGroups}
          onEdit={onEdit}
          onDelete={onDelete}
          canUpdate={canUpdate}
          canDelete={canDelete}
        />
      ))}
    </div>
  );
}
